export default "__VITE_ASSET__POd6VO2R__"